/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Shortcuts_Mock_Action_InvoiceInputs */

const tr_landing_shortcuts_mock_action_invoice = /** @type {(inputs: Landing_Shortcuts_Mock_Action_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-fatura kes`)
};

const en_landing_shortcuts_mock_action_invoice = /** @type {(inputs: Landing_Shortcuts_Mock_Action_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue e-invoice`)
};

const de_landing_shortcuts_mock_action_invoice = /** @type {(inputs: Landing_Shortcuts_Mock_Action_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Rechnung ausstellen`)
};

const ru_landing_shortcuts_mock_action_invoice = /** @type {(inputs: Landing_Shortcuts_Mock_Action_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выставить e-fatura`)
};

/**
* | output |
* | --- |
* | "Issue e-invoice" |
*
* @param {Landing_Shortcuts_Mock_Action_InvoiceInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_shortcuts_mock_action_invoice = /** @type {((inputs?: Landing_Shortcuts_Mock_Action_InvoiceInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Shortcuts_Mock_Action_InvoiceInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_shortcuts_mock_action_invoice(inputs)
	if (locale === "de") return de_landing_shortcuts_mock_action_invoice(inputs)
	if (locale === "ru") return ru_landing_shortcuts_mock_action_invoice(inputs)
	return tr_landing_shortcuts_mock_action_invoice(inputs)
});